// Open other fields when click on the search property form
jQuery(document).ready(function ($) {
    $(".awesomplete").click( function() { 
        $(".idx-omnibar-extra").show(300);
        $(".idx-omnibar-form").addClass("open");
    }); 
});